import { Copy } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

export interface ResultBoxProps {
  label: string;
  value: string;
  className?: string;
}

/** Read-only output panel with a copy-to-clipboard action. */
export function ResultBox({ label, value, className }: ResultBoxProps) {
  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value);
      toast.success("Copied to clipboard");
    } catch {
      toast.error("Couldn't access the clipboard");
    }
  }

  return (
    <div className={cn("space-y-2 rounded-md border bg-muted/40 p-4", className)}>
      <div className="flex items-center justify-between gap-2">
        <Label className="text-muted-foreground">{label}</Label>
        <Button type="button" variant="ghost" size="sm" onClick={handleCopy}>
          <Copy className="mr-2 h-4 w-4" />
          Copy
        </Button>
      </div>
      <pre className="max-h-48 overflow-auto whitespace-pre-wrap break-all font-mono text-sm">
        {value}
      </pre>
    </div>
  );
}
